<template>
<Layout>
    <div class="flex flex-col justify-center min-h-36 md:min-h-96 lg:w-3/4 md:w-2/3 mx-auto mt-2">
        <div class="flex flex-col md:flex-row">
            <div class="flex flex-col lg:w-1/2 md:w-1/2 px-2 mx-auto bg-base-200 my-2 md:my-10">
                <span class="uppercase text-xs lg:text-base font-bold">{{post.date}}</span>
                <span class="uppercase text-base font-bold">{{post.title}}</span>
                <span class="text-xs lg:text-base mt-2" v-if="post && post.text">
                    {{post.text}}
                </span>
            </div>
            <div class="lg:w-72 md:w-72 w-72 mx-auto bg-base-200 my-2 md:my-10">
                <div class="flex flex-row flex-wrap">
                    <div class="w-32 h-32 m-1" v-for="(video, i) in post.videos" :key="i">
                        <vue-core-video-player :src="`${publicPath}news/${video}`"></vue-core-video-player>
                    </div>
                    <div class="w-32 h-32 overflow-hidden m-1" v-for="(image, i) in post.images" :key="i" @click="galleryIndex = i">
                        <img :src="`${publicPath}news/${image}`" class="object-fill">
                    </div>
                </div>
                <a class="hover:text-gray-600 text-xs mt-10">
                    <router-link to="/news/archive"> archive </router-link>
                </a>
            </div>
        </div>
    </div>
        <vue-gallery-slideshow :images="images" :index="galleryIndex" @close="galleryIndex = null"></vue-gallery-slideshow>
</Layout>
</template>

        <!-- <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg md:hidden">
            <VueSlickCarousel v-bind="settings">
                <div class="overflow-hidden h-72" v-for="(productImage, id) in patternImages" :key="id">
                    <img class="w-full" :src="productImage" alt="">
                </div>
            </VueSlickCarousel>
        </div> -->

<script>
import newsJson from '../data/news.json';

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import VueGallerySlideshow from 'vue-gallery-slideshow';

import Layout from '../components/Layout.vue';

export default {
    name: "NewsPage",
    components: {
        Layout,
        VueSlickCarousel,
        VueGallerySlideshow
    },
    computed: {
        post() {
            return this.posts[this.index];
        },
        images() {
            return this.post.images.map(image => `${this.publicPath}news/${image}`);
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            posts: newsJson,
            settings: {
                "dots": true,
                "infinite": true,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "variableWidth": false,
                "arrows": false
            },
            selectedPostId: 1,
            index: 0,
            archivedVisible: false,
            galleryIndex: null
        }
    },
    methods: {
        showAll() {
            this.archivedVisible = true;
        }
    }
}
</script>

<style>
.vcp-controls {
    display: none !important;
}
</style>
